export default __webpack_public_path__ + "static/media/img_blanket_beige.fed131d5.jpg";